import { forwardRef } from 'react';

import VInnerTree from './VInnerTree';
import { VTreeContextProvider } from './context';
import type { VTreeProps, VTreeRef } from './type';

const VTree = (
  {
    autoOpen = true,
    nodeList,
    rounded,
    onClose,
    onOpen,
    onSelect,
    renderNode,
    ...rest
  }: VTreeProps & Omit<React.ComponentPropsWithoutRef<'div'>, 'onSelect'>,
  ref?: React.ForwardedRef<VTreeRef>,
) => {
  const props = {
    autoOpen,
    nodeList,
    rounded,
    onClose,
    onOpen,
    onSelect,
    renderNode,
  };

  return (
    <VTreeContextProvider {...props}>
      <VInnerTree ref={ref as any} {...rest} />
    </VTreeContextProvider>
  );
};

export default forwardRef(VTree) as (
  props: VTreeProps &
    Omit<React.ComponentPropsWithoutRef<'div'>, 'onSelect'> & {
      ref?: React.ForwardedRef<VTreeRef>;
    },
) => ReturnType<typeof VTree>;
